import { Tag } from 'antd'
import { useTranslation } from 'react-i18next'

type Props = {
  /** The user's `sso_id`; present → SSO-linked, absent → manual/password. */
  ssoId?: string | null
}

/**
 * Identity-source tag (SSO vs Manual). Shared so the markup and labels stay
 * consistent everywhere a member's sign-in source is shown — the workspace
 * users table, the app-users table, and the user-detail hero.
 */
export const SourceTag = ({ ssoId }: Props) => {
  const { t } = useTranslation()

  return (
    <Tag style={{ marginInlineEnd: 0, fontSize: 11 }}>
      {ssoId ? t('users.hero.source.sso') : t('users.hero.source.manual')}
    </Tag>
  )
}
